import React from 'react'
import { noop } from 'utilities'
import { GET_REPORTS, GET_REPORT_BY_REPORT_OBJECT, GET_MY_RECEIPT_REPORT_DETAILS } from 'requests'
import FileDownloader from 'components/FormManager/FileDownloader'
import DownloadIcon from '@tecuity/sos-icons/build/react-icons/download-box'
import { Spinner } from 'components/Loaders/Loaders'
import './ReportDownload.scss'
import shortid from 'shortid'
import { announce } from '../../actions'
import { connect } from 'react-redux'


const DOWNLOAD_ERROR = `Something went wrong while downloading this file. Try again later.`

class ReportsDownload extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: true,
      blob: null,
      downloading: false,
      fresh: false,
      oldValue: null,
      rawBlob: null,
      downloadError: false,
      emptyResult: false,
      reportDetails: null,
      reports: null,
      recordNum: null,
      formDefinitionId: null,
      isMounted: false,
    }
  }

  componentDidMount = async () => {
    if (this.props.selectedReceipt) {
      this.getFormDefinition()
      this.setState({
        ...this.state,
        downloading: false,
        oldValue: this.props.selectedReceipt.REF_NUM,
        loading: true,
        formDefinitionId: null,
        isMounted: true,
      })
    }
  }

  componentDidUpdate = (prevProps) => {
    if (
      !this.props.selectedReceipt ||
      this.state.oldValue == !this.props.selectedReceipt.REF_NUM ||
      !this.state.isMounted
    ) {
      return
    }

    try {
      if (prevProps.selectedReceipt.REF_NUM != this.props.selectedReceipt.REF_NUM) {
        this.setState({
          ...this.state,
          downloading: false,
          loading: true,
        })
        this.getFormDefinition()
      }
    } catch (error) {
      this.setState({ emptyResult: true })
      console.error(error)
    }
  }

  componentWillUnmount = () => {
    this.setState({ isMounted: false })
  }

  getFormDefinition = () => {
    this.setState({ ...this.state, loading: true })
    const reportDetailRequest = {
      RECEIPT_ITEM_ID: this.props.selectedReceipt.RECEIPT_ITEM_ID,
      SOURCE_TYPE_ID: this.props.selectedReceipt.SOURCE_TYPE_ID,
    }
    const requestId = shortid.generate()
    try {
      GET_MY_RECEIPT_REPORT_DETAILS(requestId, reportDetailRequest, (formDefinition) => {
        if (!this.state.isMounted) {
          return
        }

        if (typeof formDefinition == 'string') {
          this.setState({
            ...this.state,
            formDefinitionId: formDefinition,
          })
          this.getReports()
        } else {
          this.setState({ ...this.state, emptyResult: true, loading: false })
        }
      })
    } catch (error) {
      this.setState({ ...this.state, emptyResult: true, loading: false })
    }
  }

  getReports = () => {
    // this.setState({ loading: true })
    if (this.state.formDefinitionId) {
      GET_REPORTS(this.state.formDefinitionId, this.props.selectedReceipt.RECORD_NUM, (reports) => {
        if (!this.state.isMounted || !reports) {
          return
        }

        let receiptReport = reports.filter((obj) => {
          return obj.REPORT_NAME == 'Receipt'
        })

        this.setState({
          reports: !reports || !Array.isArray(reports) ? [] : reports,
          downloadError: false,
          emptyResult: receiptReport.length >= 1 ? false : true,
          loading: false,
        })
      })
    } else {
      this.setState({
        ...this.state,
        emptyResult: true,
        downloadError: false,
        reports: [],
        loading: false,
        oldValue: null,
      })
    }
  }

  getDownload = () => {
    if (this.state.reports.length < 1) {
      this.setState({ ...this.state, downloadError: true })
      return
    }

    this.setState({ downloading: true, downloadError: false, fresh: false })

    let receiptReport = this.state.reports.filter((obj) => {
      return obj.REPORT_NAME == 'Receipt'
    })
    GET_REPORT_BY_REPORT_OBJECT(
      receiptReport[0],
      (res) => {
        if (!this.state.isMounted) {
          return
        }
        if (res.ok) {
          if (receiptReport[0].RETURN_TYPE === 'URL') {
            res.text().then((url) => {
              this.setState(
                {
                  blob: url,
                  downloading: false,
                  downloadError: false,
                },
                () => {
                  this.downloader.download()
                }
              )
            })
          } else if (this.downloader != null) {
            res.blob().then((blob) => {
              const blobObject = window.URL.createObjectURL(blob)
              this.setState(
                { blob: blobObject, rawBlob: blob, downloading: false, downloadError: false },
                () => {
                  this.downloader.download()
                }
              )
            })
          } else {
            this.setState({ downloadError: true, downloading: false })
            this.props.announce(DOWNLOAD_ERROR)
          }
        } else {
          this.setState({ downloadError: true, downloading: false })
          this.props.announce(DOWNLOAD_ERROR)
        }
      },
      (err) => {
        this.setState({ downloadError: true, downloading: false })
        this.props.announce(DOWNLOAD_ERROR)
      }
    )
  }

  render() {
    const { animated, delay, selectedReceipt } = this.props

    return (
      <div className="report-download">
        <h5>Available Downloads</h5>
        {this.state.loading === true ? (
          <div className="reports-spinner animated fadeIn">
            <Spinner size="medium" themeColor="secondary" />
          </div>
        ) : this.state.emptyResult == false && this.state.loading === false ? (
          <button
            className={`report ${animated !== false ? 'animated fadeInUp extra-fast-animation' : ''
              } ${this.state.downloadError ? 'error' : ''}`}
            style={{ animationDelay: `${delay}ms` }}
            onClick={this.state.downloading ? noop : this.getDownload}
            title="Download Receipt"
            aria-label="Download Receipt"
          >
            <span className="download-icon">
              {this.state.downloading && <div className="shine-spinner" />}
              <DownloadIcon
                className={`icon ${this.state.fresh ? '' : this.state.downloading ? 'spin-out' : 'spin-in'
                  }`}
              />
            </span>
            <span className="labels">
              <span
                style={{ opacity: this.state.downloadError ? 1 : 0 }}
                className="download-error"
                aria-hidden={!this.state.downloadError}
                role="alert"
                aria-live="assertive"
              >
                {DOWNLOAD_ERROR}
              </span>
              <span>{`Download Receipt ${selectedReceipt ? `${selectedReceipt.REF_NUM}` : ''
                }`}</span>
            </span>
            <FileDownloader
              ref={(downloader) => {
                this.downloader = downloader
              }}
              href={this.state.blob}
              blob={this.state.rawBlob}
              fileName={`${selectedReceipt ? `Receipt_${selectedReceipt.REF_NUM}` : ''}.pdf`}
              overrideFileName
            />
          </button>
        ) : (
          <p className="error-message" aria-live="polite">
            No receipt document available for download.
          </p>
        )}
      </div>
    )
  }
}

ReportsDownload = connect(
  null,
  {
    announce,
  }
)(ReportsDownload)

export default ReportsDownload



// WEBPACK FOOTER //
// ./src/components/MyReceipts/ReportDownload.js